import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from 'antd'
import ItemsList from './ItemsList'
import { productConstants, pmsConstants } from '../../common/constants'
import css from './filter.css'

class ProductAndPmsFilter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tempProducts: props.products,
      tempPmsTypes: props.pmsTypes,
      productsModalOpen: false,
      pmsModalOpen: false,
    }
  }

  addItem = (type, item) => {
    const newItems = [...this.state[`temp${type}`], item]
    this.setState({ [`temp${type}`]: newItems })
  }

  removeItem = (type, item) => {
    const newItems = this.state[`temp${type}`].filter(i => i !== item)
    this.setState({ [`temp${type}`]: newItems })
  }

  onChange = (checked, item, type) => (
    checked
      ? this.addItem(type, item)
      : this.removeItem(type, item)
  )

  toggleModal = (type, modalOpen) =>
    this.setState({ [`${type}ModalOpen`]: modalOpen })

  handleProductClick = () => {
    this.toggleModal('products', true)
  }

  handlePmsClick = () => {
    this.toggleModal('pms', true)
  }

  handleProductsOk = () => {
    const { tempProducts } = this.state
    const { updateProducts } = this.props
    this.toggleModal('products', false)
    updateProducts(tempProducts)
  }

  handleProductsCancel = () => {
    const { products } = this.props
    this.setState({ tempProducts: products })
    this.toggleModal('products', false)
  }

  handlePmsOk = () => {
    const { tempPmsTypes } = this.state
    const { updatePmsTypes } = this.props
    this.toggleModal('pms', false)
    updatePmsTypes(tempPmsTypes)
  }

  handlePmsCancel = () => {
    const { pmsTypes } = this.props
    this.setState({ tempPmsTypes: pmsTypes })
    this.toggleModal('pms', false)
  }

  handleItemsClear = (itemType) => {
    if (itemType === 'pmsTypes') {
      this.setState({ tempPmsTypes: [] })
    } else if (itemType === 'products') {
      this.setState({ tempProducts: [] })
    }
  }

  render() {
    const {
      productsModalOpen,
      pmsModalOpen,
      tempProducts,
      tempPmsTypes,
    } = this.state
    const { isTopsAdmin } = this.props
    const productCheckboxes = productConstants(isTopsAdmin)
    const pmsCheckboxes = pmsConstants
    const productsButtonTitle =
      `Products${!tempProducts.length ? '' : ` (${tempProducts.length})`}`
    const pmsButtonTitle =
      `PMS Types ${!tempPmsTypes.length ? '' : ` (${tempPmsTypes.length})`}`

    return (
      <div className={css.productPmsContainer}>
        <Button
          className={css.productsButton}
          onClick={this.handleProductClick}
        >
          {productsButtonTitle}
        </Button>
        {!isTopsAdmin && (
          <Button className={css.pmsButton} onClick={this.handlePmsClick}>
            {pmsButtonTitle}
          </Button>
        )}
        <Modal
          title="Filter by Products"
          visible={productsModalOpen}
          onCancel={this.handleProductsCancel}
          onOk={this.handleProductsOk}
        >
          <ItemsList
            items={tempProducts}
            checkboxes={productCheckboxes}
            onChange={(checked, product) =>
              this.onChange(checked, product, 'Products')
            }
          />
          <Button
            onClick={() => this.handleItemsClear('products')}
            className={css.clearButton}
          >
            Clear
          </Button>
        </Modal>
        <Modal
          title="Filter by PMS Types"
          visible={pmsModalOpen}
          onCancel={this.handlePmsCancel}
          onOk={this.handlePmsOk}
        >
          <ItemsList
            items={tempPmsTypes}
            checkboxes={pmsCheckboxes}
            onChange={(checked, pmsType) =>
              this.onChange(checked, pmsType, 'PmsTypes')
            }
          />
          <Button
            onClick={() => this.handleItemsClear('pmsTypes')}
            className={css.clearButton}
          >
            Clear
          </Button>
        </Modal>
      </div>
    )
  }
}

ProductAndPmsFilter.propTypes = {
  products: PropTypes.arrayOf(PropTypes.string).isRequired,
  pmsTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  isTopsAdmin: PropTypes.bool.isRequired,
  updateProducts: PropTypes.func.isRequired,
  updatePmsTypes: PropTypes.func.isRequired,
}

export default ProductAndPmsFilter



// WEBPACK FOOTER //
// ./src/Dashboard/Filters/ProductAndPmsFilter.js